// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-form-answer-set-list {
  display: block;
}
.fi-form-answer-set-list .fi-wrapper-table .mat-mdc-table .mat-mdc-cell.mat-column-Name {
  padding-left: 18px;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-form/fi-form-list/fi-form-answer-set-list/fi-form-answer-set-list.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AAEY;EACI,kBAAA;AAAhB","sourcesContent":[".fi-form-answer-set-list {\r\n    display: block;\r\n    .fi-wrapper-table {\r\n        .mat-mdc-table {\r\n            .mat-mdc-cell.mat-column-Name {\r\n                padding-left: 18px;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
